export const championEmail = {
  subject: 'Your Player Is a Champion! 🏆',
  preheader: 'Celebrate the win with an official Championship Winner shirt, available for a limited time.',
  fromName: 'i9 Sports',
  fromAddress: 'hello@i9sports.com',
  logo: 'https://cdn.magicpatterns.com/uploads/4egNXSEskxSbdFkWAP1Y3M/I9_Logo_Hi_Res_Multicolor.png',
  shirtImage: 'https://cdn.magicpatterns.com/patterns/generated-images/068e7b57-c544-4fa6-8f92-122f71968949.jpg',
  supportHours: 'Monday – Friday, 9 AM – 6 PM ET',
};

export const emailProductDetails = [
  { label: 'Color', value: 'Navy & Athletic Gold' },
  { label: 'Material', value: '100% Pre-Shrunk Ring-Spun Cotton' },
];

export const emailSocials = ['facebook', 'instagram', 'x', 'youtube'] as const;

export const emailFooterLinks = [
  'Unsubscribe',
  'Manage Email Preferences',
  'Privacy Policy',
  'Terms of Service',
  'View in Browser',
];

export const emailConfetti = [
  { kind: 'star', left: '6%', top: '10%', color: '#F6B931', rotate: 15, size: 14 },
  { kind: 'dot', left: '12%', top: '18%', color: '#8DBBF7', rotate: 0, size: 6 },
  { kind: 'star', left: '10%', top: '34%', color: '#F6B931', rotate: -10, size: 18 },
  { kind: 'dot', left: '4%', top: '52%', color: '#F6B931', rotate: 0, size: 5 },
  { kind: 'star', left: '3%', top: '70%', color: '#F6B931', rotate: 20, size: 16 },
  { kind: 'dot', left: '9%', top: '82%', color: '#8DBBF7', rotate: 0, size: 6 },
  { kind: 'dot', left: '90%', top: '10%', color: '#8DBBF7', rotate: 0, size: 6 },
  { kind: 'star', left: '86%', top: '22%', color: '#F6B931', rotate: 10, size: 18 },
  { kind: 'dot', left: '94%', top: '40%', color: '#F6B931', rotate: 0, size: 5 },
  { kind: 'star', left: '91%', top: '58%', color: '#F6B931', rotate: -15, size: 16 },
  { kind: 'dot', left: '85%', top: '74%', color: '#8DBBF7', rotate: 0, size: 6 },
  { kind: 'star', left: '88%', top: '86%', color: '#F6B931', rotate: 25, size: 12 },
];
